import React, { Component } from "react";
import '../services.css';

const PROFILE_URL = "https://x.com/JeffLesson";

const XLogo = ({ className = "x-logo" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
    />
  </svg>
);

export class Services extends Component {

  componentDidMount() {
    this.mountHashtag();
  }

  mountHashtag() {
    const hashtagHost = document.getElementsByClassName("hashtag-embed")[0];
    if (!hashtagHost) return;

    hashtagHost.innerHTML = "";

    const hashtagAnchor = document.createElement("a");
    hashtagAnchor.setAttribute(
      "href",
      "https://twitter.com/intent/tweet?button_hashtag=lessonongolf&ref_src=twsrc%5Etfw"
    );
    hashtagAnchor.setAttribute("class", "twitter-hashtag-button");
    hashtagAnchor.setAttribute("data-size", "large");
    hashtagAnchor.setAttribute("data-show-count", "false");
    hashtagAnchor.textContent = "Tweet #lessonongolf";
    hashtagHost.appendChild(hashtagAnchor);

    if (window.twttr && window.twttr.widgets) {
      window.twttr.widgets.load();
    } else if (!document.getElementById("twitter-wjs")) {
      const script = document.createElement("script");
      script.setAttribute("id", "twitter-wjs");
      script.setAttribute("src", "https://platform.twitter.com/widgets.js");
      script.setAttribute("charset", "utf-8");
      script.async = true;
      document.body.appendChild(script);
    }
  }

  render() {
    return (
      <div id="services" className="text-center">
        <div className="container">
          <div className="section-title">
            <span className="x-eyebrow">
              <XLogo className="x-logo x-logo-sm" /> Follow on X
            </span>
            <h2>Follow @JeffLesson</h2>
            <p className="x-sub">
              Pro pointers, course reviews and golf news — straight from Jeff.
            </p>

            <a
              className="big-follow"
              target="_blank"
              rel="noopener noreferrer"
              href={PROFILE_URL}
            >
              <XLogo className="x-logo" />
              <span>Follow on X</span>
            </a>

            <div className="hashtag-cta">
              <p className="hashtag-label">Join the conversation</p>
              <div className="hashtag-embed"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Services;
